import React from "react";
import { List, ListItem, IconButton } from "@material-ui/core";
import { ListGroup, ListGroupItem, Col, Row } from "reactstrap";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import GetAppIcon from "@material-ui/icons/GetApp";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExcel, faFileImage, faFileWord, faFilePdf, faFilePowerpoint, faFileVideo, faFileAudio } from "@fortawesome/free-solid-svg-icons";
import { toKebabCase } from "../../../helpers/cssHelper";
import LanguageOutlinedIcon from "@material-ui/icons/LanguageOutlined";
import { clickTrackLog } from "../../../services/clickTrack.service";

export default class ExpoFileList extends React.Component {
  render() {
    const renderFileIcon = (value) => {
      let type = value.substring(value.lastIndexOf(".") + 1, value.length);
      switch (type) {
        case "jpg":
        case "jif":
        case "png":
        case "svg":
          return (
            <FontAwesomeIcon
              style={{
                fontSize: 24,
                marginTop: 0,
                color: "#632c88",
                backgroundColor: "#632c8807",
                width: 40,
                height: 40,
                borderRadius: "50%",
                padding: 10,
              }}
              icon={faFileImage}
            />
          );
        case "pdf":
          return (
            <FontAwesomeIcon
              style={{
                fontSize: 24,
                marginTop: 0,
                color: "#d91516",
                backgroundColor: "#d9151607",
                width: 40,
                height: 40,
                borderRadius: "50%",
                padding: 10,
              }}
              icon={faFilePdf}
            />
          );
        case "doc":
        case "docx":
          return (
            <FontAwesomeIcon
              style={{
                fontSize: 24,
                marginTop: 0,
                color: "#285294",
                backgroundColor: "#28529407",
                width: 40,
                height: 40,
                borderRadius: "50%",
                padding: 10,
              }}
              icon={faFileWord}
            />
          );
        case "xls":
        case "xlsx":
          return (
            <FontAwesomeIcon
              style={{
                fontSize: 24,
                marginTop: 0,
                color: "#026f39",
                backgroundColor: "#026f3907",
                width: 40,
                height: 40,
                borderRadius: "50%",
                padding: 10,
              }}
              icon={faFileExcel}
            />
          );
        case "ppt":
        case "pptx":
          return (
            <FontAwesomeIcon
              style={{
                fontSize: 24,
                marginTop: 0,
                color: "#c64331",
                backgroundColor: "#c6433107",
                width: 40,
                height: 40,
                borderRadius: "50%",
                padding: 10,
              }}
              icon={faFilePowerpoint}
            />
          );
        case "mp4":
        case "mpg":
        case "mpeg":
        case "avi":
        case "mov":
        case "mkv":
          return (
            <FontAwesomeIcon
              style={{
                fontSize: 24,
                marginTop: 0,
                color: "#c64331",
                backgroundColor: "#c6433107",
                width: 40,
                height: 40,
                borderRadius: "50%",
                padding: 10,
              }}
              icon={faFileVideo}
            />
          );
        case "mp3":
        case "wav":
          return (
            <FontAwesomeIcon
              style={{
                fontSize: 24,
                marginTop: 0,
                color: "#c64331",
                backgroundColor: "#c6433107",
                width: 40,
                height: 40,
                borderRadius: "50%",
                padding: 10,
              }}
              icon={faFileAudio}
            />
          );
        default:
          return null;
      }
    };

    const { files = [], links = false, template = undefined, clientKey, eventId, exhibitorId } = this.props;
    return (
      <div>
        <style>{template && template.content ? `${toKebabCase(template.scrollbar, true, true)}` : ""}</style>

        <ListGroup
          className="jir-scroll"
          style={{
            minHeight: "calc(45vh - 69px)",
            maxHeight: "calc(45vh - 69px)",
            overflowY: "auto",
            paddingBottom: 20,
          }}
        >
          {files
            .sort(function (a, b) {
              return a.sortOrder - b.sortOrder;
            })
            .map((f, i) => {
              return (
                <ListGroupItem
                  className="smooth-shadow"
                  key={i}
                  style={{ border: 0, cursor: "pointer" }}
                  onClick={() =>
                    clickTrackLog(eventId, exhibitorId, clientKey, f.name, f.value2, "Exhibitor", () => {
                      if (f.value2 && typeof f.value2 === "string") {
                        let link = f.value2;
                        if (!link.toLowerCase().startsWith("http")) {
                          link = "https://" + link;
                        }
                        window.open(link, "_blank");
                      }
                    })
                  }
                >
                  <Row>
                    {!links ? (
                      <Col className="col-2 text-left">{renderFileIcon(f.value2)}</Col>
                    ) : (
                      <Col className="col-2 text-left">
                        <LanguageOutlinedIcon
                          style={{
                            fontSize: 24,
                            marginTop: 0,
                            color: "#285294",
                            backgroundColor: "#28529426",
                            width: 40,
                            height: 40,
                            borderRadius: "50%",
                            padding: 10,
                          }}
                        />{" "}
                      </Col>
                    )}
                    <Col
                      className={`col-8 text-left ellipsis`}
                      style={
                        template
                          ? {
                              fontFamily: template ? template.text.fontFamily : undefined,
                              paddingTop: 0,
                              color: "#5e5e5e",
                            }
                          : { paddingTop: 15 }
                      }
                    >
                      {f.value}
                      <br />
                      {links ? (
                        <em style={{ fontSize: 12, color: "#285294" }}>{f.value2}</em>
                      ) : (
                        <em style={{ fontSize: 12, color: "gray" }}>{f.value2.substring(f.value2.lastIndexOf(".") + 1, f.value2.length)}</em>
                      )}
                    </Col>
                    <Col className="col-2 text-right">
                      <IconButton
                        onClick={() =>
                          clickTrackLog(eventId, exhibitorId, clientKey, f.name, f.value2, "Exhibitor", () => {
                            if (f.value2 && typeof f.value2 === "string") {
                              let link = f.value2;
                              if (!link.toLowerCase().startsWith("http")) {
                                link = "https://" + link;
                              }
                              window.open(link, "_blank");
                            }
                          })
                        }
                        style={{ border: "1px solid gainsboro" }}
                      >
                        {f.name == "Link" ? <ArrowForwardIcon /> : <GetAppIcon />}
                      </IconButton>
                    </Col>
                  </Row>
                </ListGroupItem>
              );
            })}
        </ListGroup>
      </div>
    );
  }
}
